import { Link } from '@periodica/ui-kit';
import { Paragraph as P } from '@periodica/ui-kit';
import React from 'react';

export function SubscribeAgreementText() {
  return (
    <P color="secondary">
      Даю&nbsp;
      <Link href="/subscription-consent-new/" target="_blank">
        согласие
      </Link>
      &nbsp;на&nbsp;обработку персональных данных и&nbsp;получение рассылки в&nbsp;соответствии
      с&nbsp;
      <Link href="/privacy/" target="_blank">
        политикой конфиденциальности
      </Link>
      .
    </P>
  );
}
